import { recordCameraState } from "./cameraTelemetry"
import { useEffect, useRef } from "react"

/**
 * Records the initial camera state once connected to prevent 0 cam duration.
 *
 * Without this, if the camera starts ON and stays ON for the entire session,
 * no cam_toggle event is ever recorded (the debounced toggle handler never fires),
 * resulting in the backend computing 0 cam duration.
 *
 * @param {boolean} isConnected - Whether the LiveKit room is connected
 * @param {object}  room        - The LiveKit room instance (from useRoomContext)
 */
export function useInitialCamRecord(isConnected, room) {
    const recordedRef = useRef(false)

    useEffect(() => {
        if (isConnected && !recordedRef.current) {
            recordedRef.current = true
            const camEnabled = room?.localParticipant?.isCameraEnabled
            if (camEnabled != null) {
                recordCameraState(room, camEnabled)
            }
        }
    }, [isConnected])
}
